import Colors, { blend, withOpacity, } from '@polestar/component-warehouse-react/tokens/colors/Colors';
import Opacities, { createCustomOpacity, } from '@polestar/component-warehouse-react/tokens/opacities/Opacities';
import Spacings from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import FontSizes, { createCustomFontSize, } from '@polestar/component-warehouse-react/tokens/font-sizes/FontSizes';
const SelectableTheme = {
    selectable: {
        light: {
            listBackground: blend(Colors.white, Colors.agatheGrey, Opacities.xLow),
            sizes: {
                small: {
                    icon: {
                        size: Spacings.large,
                        fontSize: createCustomFontSize(1),
                    },
                },
                medium: {
                    icon: {
                        size: Spacings.xLarge,
                        fontSize: FontSizes.body,
                    },
                },
                large: {
                    icon: {
                        size: Spacings.xxLarge,
                        fontSize: FontSizes.body,
                    },
                },
            },
            states: {
                enabled: {
                    background: Colors.white,
                    color: Colors.black,
                    borderColor: blend(Colors.white, Colors.black, Opacities.xLow),
                    // Todo: remove iconSelected from all states, it is not needed anymore
                    // All variants can use background, color and border only
                    icon: {
                        background: blend(Colors.white, Colors.agatheGrey, Opacities.xLow),
                        color: Colors.black,
                        border: blend(Colors.white, Colors.black, Opacities.medium),
                    },
                    iconSelected: {
                        background: Colors.accessibleSafetyOrange,
                        color: Colors.black,
                        border: Colors.accessibleSafetyOrange,
                    },
                    // Todo: remove minimalNumbered from all states, it is not needed anymore
                    // All variants can use background, color and border only
                    minimalNumbered: {
                        background: Colors.white,
                        color: Colors.black,
                        border: blend(Colors.white, Colors.black, Opacities.low),
                    },
                },
                hover: {
                    background: blend(Colors.white, Colors.signalWhite, Opacities.medium),
                    color: Colors.black,
                    borderColor: blend(Colors.white, Colors.black, Opacities.xLow),
                    icon: {
                        background: blend(Colors.white, Colors.agatheGrey, Opacities.xLow),
                        color: Colors.black,
                        border: Colors.black,
                    },
                    iconSelected: {
                        background: Colors.accessibleSafetyOrange,
                        color: Colors.black,
                        border: Colors.accessibleSafetyOrange,
                    },
                    minimalNumbered: {
                        background: blend(Colors.white, Colors.signalWhite, Opacities.medium),
                        color: Colors.black,
                        border: blend(Colors.white, Colors.black, Opacities.medium),
                    },
                },
                disabled: {
                    background: Colors.white,
                    color: Colors.black,
                    borderColor: blend(Colors.white, Colors.black, Opacities.xLow),
                    icon: {
                        background: blend(Colors.white, Colors.agatheGrey, Opacities.xLow),
                        color: Colors.black,
                        border: blend(Colors.white, Colors.black, Opacities.medium),
                    },
                    iconSelected: {
                        background: blend(Colors.white, Colors.black, Opacities.low),
                        color: Colors.white,
                        border: blend(Colors.white, Colors.black, Opacities.low),
                    },
                    minimalNumbered: {
                        background: Colors.white,
                        color: Colors.black,
                        border: blend(Colors.white, Colors.black, Opacities.low),
                    },
                    contentOpacity: createCustomOpacity(0.4),
                    overlay: withOpacity(Colors.white, Opacities.medium),
                },
                active: {
                    background: Colors.white,
                    color: Colors.black,
                    borderColor: Colors.accessibleSafetyOrange,
                    monochromeBorderColor: Colors.black,
                    icon: {
                        background: blend(Colors.white, Colors.agatheGrey, Opacities.xLow),
                        color: Colors.black,
                        border: Colors.accessibleSafetyOrange,
                    },
                    iconSelected: {
                        background: Colors.accessibleSafetyOrange,
                        color: Colors.black,
                        border: Colors.accessibleSafetyOrange,
                        monochrome: {
                            background: Colors.black,
                            color: Colors.white,
                            border: Colors.black,
                        },
                    },
                    minimalNumbered: {
                        background: Colors.white,
                        color: Colors.black,
                        border: Colors.accessibleSafetyOrange,
                        monochromeBorderColor: Colors.black,
                    },
                },
            },
        },
        dark: {
            listBackground: blend(Colors.black, Colors.white, Opacities.xLow),
            states: {
                enabled: {
                    background: Colors.black,
                    color: Colors.white,
                    borderColor: blend(Colors.black, Colors.white, Opacities.low),
                    icon: {
                        background: blend(Colors.black, Colors.white, Opacities.xLow),
                        color: Colors.white,
                        border: blend(Colors.black, Colors.white, Opacities.medium),
                    },
                    iconSelected: {
                        background: Colors.accessibleSafetyOrange,
                        color: Colors.black,
                        border: Colors.accessibleSafetyOrange,
                    },
                    minimalNumbered: {
                        background: Colors.black,
                        color: Colors.white,
                        border: blend(Colors.black, Colors.white, Opacities.low),
                    },
                },
                hover: {
                    background: blend(Colors.black, Colors.greyChateau, Opacities.xLow),
                    color: Colors.white,
                    borderColor: blend(Colors.black, Colors.white, Opacities.low),
                    icon: {
                        background: blend(Colors.black, Colors.white, Opacities.xLow),
                        color: Colors.white,
                        border: Colors.white,
                    },
                    iconSelected: {
                        background: Colors.accessibleSafetyOrange,
                        color: Colors.black,
                        border: Colors.accessibleSafetyOrange,
                    },
                    minimalNumbered: {
                        background: blend(Colors.black, Colors.greyChateau, Opacities.xLow),
                        color: Colors.white,
                        border: blend(Colors.black, Colors.white, Opacities.low),
                    },
                },
                disabled: {
                    // Todo: remove all states but the contentOpacity and overlay from disabled
                    // The others aren't used in our component anymore
                    background: Colors.black,
                    color: Colors.white,
                    borderColor: blend(Colors.black, Colors.white, Opacities.low),
                    icon: {
                        background: blend(Colors.black, Colors.white, Opacities.xLow),
                        color: Colors.white,
                        border: blend(Colors.black, Colors.white, Opacities.medium),
                    },
                    iconSelected: {
                        background: blend(Colors.black, Colors.white, Opacities.low),
                        color: Colors.black,
                        border: blend(Colors.black, Colors.white, Opacities.low),
                    },
                    minimalNumbered: {
                        background: Colors.black,
                        color: Colors.white,
                        border: blend(Colors.black, Colors.white, Opacities.low),
                    },
                    contentOpacity: createCustomOpacity(0.4),
                    overlay: withOpacity(Colors.black, Opacities.medium),
                },
                active: {
                    background: Colors.black,
                    color: Colors.white,
                    borderColor: Colors.accessibleSafetyOrange,
                    monochromeBorderColor: Colors.white,
                    icon: {
                        background: blend(Colors.black, Colors.white, Opacities.xLow),
                        color: Colors.white,
                        border: Colors.accessibleSafetyOrange,
                    },
                    iconSelected: {
                        background: Colors.accessibleSafetyOrange,
                        color: Colors.black,
                        border: Colors.accessibleSafetyOrange,
                        monochrome: {
                            background: Colors.white,
                            color: Colors.black,
                            border: Colors.white,
                        },
                    },
                    minimalNumbered: {
                        background: Colors.black,
                        color: Colors.white,
                        border: Colors.accessibleSafetyOrange,
                        monochromeBorderColor: Colors.white,
                    },
                },
            },
        },
    },
};
export default SelectableTheme;
